import React from 'react';
import useStyles from './useStyles';

import { CustomizedButton, CustomizedTypography } from '@components/Customized';

import useFiles from '@hooks/useFiles';

import { documentDateFormat } from '@utils/formatter';

import { Download } from '@carbon/icons-react';

import { CapaQuotationRfqPurchaseOrder } from '@generated/graphql';

interface PurchaseOrderTitleProps {
  projectName?: string;
  currentItem?: CapaQuotationRfqPurchaseOrder;
}

const PurchaseOrderTitle = ({
  currentItem,
  projectName
}: PurchaseOrderTitleProps) => {
  const classes = useStyles();

  const id = currentItem?.id;
  const createdAt = currentItem?.createdAt;

  const { onDownloadPdf } = useFiles();

  const onDownloadPurchaseOrder = () => {
    if (!id) return null;

    onDownloadPdf('purchaseorder', id, projectName);
  };

  return (
    <div className={classes.containerTitle}>
      <div className="alignRow">
        <CustomizedTypography variant="h3" color="textPrimary" fontWeight="700">
          {projectName}
        </CustomizedTypography>
        <CustomizedTypography variant="body2" color="textSecondary">
          {documentDateFormat(new Date(createdAt ?? 0).toString())}
          &nbsp;발행
        </CustomizedTypography>
      </div>
      <div className="alignRow iconButtonGroup">
        <CustomizedButton
          onClick={onDownloadPurchaseOrder}
          style={{
            paddingRight: 0
          }}
          variant="text"
          color="dark"
          startIcon={<Download size={20} />}
        >
          발주서 다운로드
        </CustomizedButton>
      </div>
    </div>
  );
};

export default PurchaseOrderTitle;
